import { Injectable } from '@angular/core';

import { UpdateLogsGetResponse } from '@reach/interfaces/update-logs/update-logs.interface';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class UpdateLogsApiService extends BaseApiService {
	protected commonPath = ['update-logs'];

	public async getUpdateLogs(): Promise<UpdateLogsGetResponse> {
		return await this.http.get<UpdateLogsGetResponse>(this.url('')).then((groups) =>
			groups.map((g) => ({
				...g,
				slides: g.slides.sort((a, b) => a.index - b.index),
			}))
		);
	}

	public async getAllUpdateLog(): Promise<UpdateLogsGetResponse> {
		return await this.http.get<UpdateLogsGetResponse>(this.url('all'));
	}

	public async markAsSeen(): Promise<void> {
		return await this.http.post<void>(this.url('seen'));
	}
}
